module.exports = __webpack_public_path__ + "media/images/flags/mw-d5ff4688383a2708f70cbea93ebfa1bf.svg";